import { useState } from "react";
import { Link } from "react-router-dom";
import {
  MusicNotes,
  SpeakerHigh,
  Microphone,
  Sparkle,
  HandsPraying,
  Heart,
  Lightning,
  ArrowRight,
  Lock,
} from "@phosphor-icons/react";

const moods = [
  { id: "peaceful", label: "Peaceful", icon: Heart },
  { id: "deep-worship", label: "Deep Worship", icon: MusicNotes },
  { id: "healing", label: "Healing", icon: Sparkle },
  { id: "instrumental", label: "Instrumental", icon: SpeakerHigh },
  { id: "choir", label: "Choir", icon: Microphone },
  { id: "powerful-praise", label: "Powerful Praise", icon: Lightning },
];

export default function WorshipPage() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="px-5 md:px-8 py-4 max-w-lg mx-auto" data-testid="worship-page">
      <div className="text-center mb-8">
        <h1 className="font-heading text-3xl text-[#2D1B0E] font-medium mb-2">Worship</h1>
        <p className="text-[#8B7355] font-body text-sm">Create your worship atmosphere</p>
      </div>

      {/* Orb */}
      <div className="relative flex justify-center mb-8">
        <div className="spiritual-orb-connect w-48 h-48 animate-orb" style={{ position: "relative" }} />
      </div>

      {/* Mood Selection */}
      <div className="mb-6">
        <h3 className="font-heading text-lg text-[#2D1B0E] font-medium mb-4 text-center">Choose Atmosphere</h3>
        <div className="grid grid-cols-3 gap-3">
          {moods.map((m) => (
            <button key={m.id} onClick={() => setSelected(m.id)} data-testid={`mood-${m.id}`}
              className={`glass-card p-4 text-center transition-all hover:-translate-y-0.5 ${selected === m.id ? "ring-1 ring-[#C4A265] bg-white/70" : ""}`}>
              <m.icon size={22} weight="duotone" className="text-[#5C4033] mx-auto mb-1.5" />
              <p className="font-body text-[10px] text-[#2D1B0E]">{m.label}</p>
            </button>
          ))}
        </div>
      </div>

      {/* Generate Button */}
      <button disabled={!selected} data-testid="generate-worship-btn"
        className="w-full py-3.5 rounded-full glass-card-strong text-[#5C4033] font-heading text-lg font-medium hover:bg-white/80 transition-all disabled:opacity-40 mb-4">
        Create Atmosphere
      </button>

      {/* Premium Upsell */}
      <div className="glass-card p-5 text-center" data-testid="worship-premium">
        <Lock size={18} className="text-[#C4A265] mx-auto mb-2" />
        <h4 className="font-heading text-base text-[#2D1B0E] font-medium mb-1">Go Deeper</h4>
        <p className="text-[#8B7355] font-body text-xs mb-3">
          Unlock AI-generated worship experiences, saved sessions, and immersive prayer atmospheres.
        </p>
        <Link to="/give" className="inline-flex items-center gap-1 text-[#C4A265] text-xs font-body font-medium">
          Explore Premium <ArrowRight size={12} />
        </Link>
      </div>
    </div>
  );
}
